
import { css } from 'lit';
export default css`
:root{
  display:block;
}

pc-filter .facet-search{
  position:relative;
  margin-bottom:var(--spacing-5);
  padding:0 0 0 var(--spacing-8);
}

pc-filter .facets-soft-limit-link{
  margin:15px;
  font-weight:500;
  position:relative;
  top:7px;
}

pc-filter .facet-search input{
  box-sizing:border-box;
  border:1px solid var(--purple-medium-neutral);
  border-radius:var(--spacing-2);
  background-color:var(--neutral-light);
  background-image:url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.20041 6.15092C9.20041 8.1843 7.57158 9.80183 5.6002 9.80183C3.62883 9.80183 2 8.1843 2 6.15092C2 4.11753 3.62883 2.5 5.6002 2.5C7.57158 2.5 9.20041 4.11753 9.20041 6.15092ZM9.2702 10.4194C8.28733 11.2806 7.0041 11.8018 5.6002 11.8018C2.5073 11.8018 0 9.27183 0 6.15092C0 3.03 2.5073 0.5 5.6002 0.5C8.69311 0.5 11.2004 3.03 11.2004 6.15092C11.2004 7.12605 10.9556 8.04349 10.5247 8.8441L16.7038 15.0792L15.296 16.4997L9.2702 10.4194Z' fill='%235B39B7'/%3E%3C/svg%3E");
  background-position:center left var(--spacing-2);
  background-repeat:no-repeat;
  background-size:var(--spacing-4);
  padding:var(--spacing-2) var(--spacing-2) var(--spacing-2) var(--spacing-8);
  width:100%;
  font-size:var(--fs-caption-mobile);
  line-height:var(--lh-caption-mobile);
}

pc-filter .facet-search input:focus{
  outline:none;
}

pc-filter .facet-search pc-icon{
  display:block;
  position:absolute;
  top:50%;
  left:var(--spacing-10);
  transform:translateY(-50%);
  color:var(--purple-indigo);
}

pc-filter .facet-search input::placeholder{
  color:var(--neutral-charcoal);
  font-size:var(--fs-caption-mobile);
  line-height:var(--lh-caption-mobile);
}

pc-filter .facet-items{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
  padding:0 var(--spacing-2) 0 var(--spacing-8);
  padding-right:var(--spacing-4);
  max-height:442px;
  overflow-x:auto;
}

pc-filter .facet-items::-webkit-scrollbar{
  width:2px;
}

pc-filter .facet-items::-webkit-scrollbar-thumb{
  background-color:var(--purple-indigo);
}

pc-filter .facet-item a{
  display:flex;
  justify-content:flex-start;
  align-items:flex-start;
  gap:var(--spacing-2);
}

pc-filter .facet-item .facet-item__value{
  color:var(--neutral-charcoal);
  font-size:var(--fs-caption-mobile);
  line-height:var(--lh-caption-mobile);
}

pc-filter .facet-item .facet-item__status{
  display:inline-block;
  position:relative;
  top:3px;
  flex-shrink:0;
  border:1px solid var(--primary-eggplant);
  border-radius:2px;
  width:var(--spacing-3);
  height:var(--spacing-3);
  font-size:0;
}

pc-filter .facet-item a.is-active .facet-item__status::after{
  display:block;
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  margin:auto;
  border-radius:1px;
  background-color:var(--purple-indigo);
  width:var(--spacing-2);
  height:var(--spacing-2);
  content:'';
}

pc-filter .facet-message{
  font-size:var(--fs-caption-mobile);
  line-height:var(--lh-caption-mobile);
}

@media (min-width: 768px){
  pc-filter .facet-search{
    margin-right:calc(var(--spacing-2) * -1);
    margin-bottom:var(--spacing-4);
    border-bottom:1px solid var(--purple-medium-neutral);
    padding:var(--spacing-4);
  }

  pc-filter .facet-message,
  pc-filter .facet-search input,
  pc-filter .facet-search input::placeholder{
    font-size:var(--fs-caption);
    line-height:var(--lh-caption);
  }

  pc-filter .facet-items{
    padding:0 var(--spacing-2) 0 var(--spacing-4);
  }

  pc-filter .facet-item .facet-item__value{
    font-size:var(--fs-caption);
    line-height:var(--lh-caption);
  }
}
`;